import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAplj8hL_PtfeKwMXvBTKCMj9dQ_MzZFnA",
  authDomain: "festi-suggest.firebaseapp.com",
  projectId: "festi-suggest",
  storageBucket: "festi-suggest.appspot.com",
  messagingSenderId: "8797732753",
  appId: "1:8797732753:web:18e5bff292900f88212430",
  measurementId: "G-5Z6S6NZFZN"
}


export default initializeApp(firebaseConfig);
